/**
 * /dashboard/payroll/new — Create a new payroll run (G5.5,
 * POST /api/v1/payroll/runs).
 *
 * HR-admin only (PayrollRoleGate mirrors backend RBAC). RunForm handles
 * the post-create redirect to /dashboard/payroll/$id (via useNavigate
 * inside the form).
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/payroll/new/page.tsx.
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { PayrollModuleShell } from "@/components/shared/payroll-module-shell";
import { RunForm } from "@/components/payroll/run-form";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/payroll/new")({
  component: NewPayrollRunRoute,
});

function NewPayrollRunRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <PayrollModuleShell
      title="New payroll run"
      description="Pick a calendar month and the engine seeds a run from every active employee."
      actions={
        <Button asChild variant="outline" className="gap-1.5">
          <Link to="/app/$tenantSlug/payroll" params={{ tenantSlug }}>
            <ArrowLeft aria-hidden className="h-4 w-4" />
            Back
          </Link>
        </Button>
      }
    >
      <Card className="max-w-2xl">
        <CardContent className="pt-6">
          <RunForm />
        </CardContent>
      </Card>
    </PayrollModuleShell>
  );
}
